import m from "../../geodata/es2015/irelandLow";
window.am4geodata_irelandLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/irelandLow.js
// module id = null
// module chunks = 